import styled from '@benzinga/themetron';
import React from 'react';

export const TestPreferenceSection: React.FC<
  React.PropsWithChildren<{
    title?: string;
    subtitle?: string;
    helpIcon?: React.ReactNode;
  }>
> = props => {
  return (
    <Wrapper>
      <Row>
        {props.title && <Title>{props.title}</Title>}
        {props.subtitle && <Subtitle>{props.subtitle}</Subtitle>}
        {props.helpIcon && <IconWrapper>{props.helpIcon}</IconWrapper>}
      </Row>
      {props.children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  padding: 1.5em 0em;
  flex-direction: column;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.foregroundActive};
  font-family: 'Nimbus Sans D OT', Helvetica;
  font-size: 1.5em;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 32px;
  margin-top: -1px;
  margin-bottom: 0.25em;
  position: relative;
  white-space: nowrap;
  width: fit-content;
  display: flex;
`;

const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.foregroundActive};
  font-family: 'Nimbus Sans D OT';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
  margin-bottom: 8px;
  display: flex;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0px;
`;
const IconWrapper = styled.div``;
